import React from "react";
import styled from "styled-components";
import { Theme } from "../../themes/theme";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const EyebrowLine = styled.span`
  display: inline-block;
  width: 24px;
  height: 1.5px;
  background: ${Theme.color.text.primary};
`;

const EyebrowText = styled.span`
  text-transform: uppercase;
  color: ${Theme.color.text.primary};
  font-size: ${Theme.font.fontSize.sm};
  font-weight: ${Theme.font.fontWeight.medium};
  letter-spacing: ${Theme.font.letterSpacing.wide};
`;

function Eyebrow({ text }) {
  return (
    <Wrapper>
      <EyebrowLine />
      <EyebrowText>{text}</EyebrowText>
    </Wrapper>
  );
}

export default Eyebrow;
